<svg
	[class.p-stroke-component-background]="!done"
	[class.p-stroke-primary]="done"
	[style.height.px]="heightPx"
	class="p-fill-primary"
	viewBox="-944 519 30 47.638"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M-929 565.117v-26.3"
		fill="none"
		stroke-linecap="round"
		stroke-width="3"
	/>
	<defs>
		<filter
			filterUnits="userSpaceOnUse"
			height="27"
			id="mp_filter"
			width="27"
			x="-942.5"
			y="513.8"
		>
			<feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
		</filter>
		<path
			d="M-927.6 517.4l8.5 8.5a1.93 1.93 0 0 1 0 2.8l-8.5 8.5a1.93 1.93 0 0 1-2.8 0l-8.5-8.5a1.93 1.93 0 0 1 0-2.8l8.5-8.5a1.93 1.93 0 0 1 2.8 0z"
			id="mp_path"
		/>
	</defs>
	<mask
		height="27"
		id="mp_mask"
		maskUnits="userSpaceOnUse"
		width="27"
		x="-942.5"
		y="513.8"
	>
		<use fill="#fff" filter="url(#mp_filter)" xlink:href="#mp_path" />
	</mask>
	<use
		fill="none"
		xlink:href="#mp_path"
		mask="url(#mp_mask)"
		stroke-width="6"
		transform="translate(0 2.117)"
	/>
	<path
		*ngIf="done"
		d="M-927.7 526.517l1.5 1.5a1.93 1.93 0 0 1 0 2.8l-1.5 1.5a1.93 1.93 0 0 1-2.8 0l-1.5-1.5a1.93 1.93 0 0 1 0-2.8l1.5-1.5c.7-.8 2-.8 2.8 0z"
	/>
	<path *ngIf="parallel" d="M-914 565.117h-30" fill="none" stroke-width="3" />
</svg>
